import { BRAND, CONTACT, HERO_IMAGE } from "@/lib/brand";
import { MapPin, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section id="home" data-testid="hero-section" className="relative pt-20">
      <div className="relative min-h-[86vh] w-full overflow-hidden">
        <img
          src={HERO_IMAGE}
          alt="Stationery store interior"
          loading="eager"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/70" />
        {/* Brand color glow */}
        <div
          className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full opacity-40 blur-3xl"
          style={{
            background:
              "radial-gradient(circle, #cb05a5 0%, transparent 70%)",
          }}
        />
        <div
          className="absolute -top-32 -left-40 w-[520px] h-[520px] rounded-full opacity-40 blur-3xl"
          style={{
            background:
              "radial-gradient(circle, #299fe0 0%, transparent 70%)",
          }}
        />

        <div className="relative mx-auto max-w-6xl px-6 md:px-10 h-full flex flex-col justify-center pt-16 pb-24 min-h-[86vh]">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 self-start px-4 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/30 text-white text-xs uppercase tracking-[0.25em] font-semibold"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#cb05a5]" />
            New Chandigarh · Punjab
          </span>

          <h1
            data-testid="hero-headline"
            className="font-display text-white font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight mt-6 max-w-4xl"
          >
            Welcome to{" "}
            <span
              style={{
                background:
                  "linear-gradient(120deg, #ffffff 0%, #b6e2f5 50%, #f7c6ea 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {BRAND.fullName}
            </span>{" "}
            — a curated space for timeless stationery and paper goods.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 max-w-2xl text-lg text-white/85 leading-relaxed"
          >
            Discover thoughtfully selected stationery, journals, planners, fine
            writing instruments, desk accessories, gift wrapping essentials, and
            much more. Visit our store to explore the complete collection in
            person.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-directions-btn"
              className="inline-flex items-center gap-2 px-6 py-4 rounded-full bg-white text-slate-900 font-semibold hover:bg-slate-100 transition-colors shadow-lg"
            >
              <MapPin size={18} className="text-[#cb05a5]" />
              Get Directions on Google Maps
              <ArrowRight size={16} />
            </a>
            <a
              href="#collections"
              className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/40 text-white font-semibold hover:bg-white/10 transition-colors"
            >
              Explore Collections
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
